// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__3xbtU","name":"ConsentHeader_name__2dOwn","birthday":"ConsentHeader_birthday__2K_dq","skeleton":"ConsentHeader_skeleton__ErQje"};